import React from "react";

class VendorComponent extends React.Component {
  constructor(props) {
    super();
    this.state = {
      vendor_id: "",
      vendor_name: "",
      acct_number: "",
      bank_details: "",
      address: "",
      phone_number: "",
      gst: "",
      item_of_supply: "",
    };
  }

  updateVendorState = (vendor) => {
    this.setState({
      vendor_id: vendor.id,
      vendor_name: vendor.vendor_name,
      acct_number: vendor.acct_number,
      bank_details: vendor.bank_details,
      address: vendor.address,
      phone_number: vendor.phone_number,
      gst: vendor.gst,
      item_of_supply: vendor.item_of_supply,
    });
  };

  render() {
    return (
      <div>
        {/* Add Vendor Modal */}
        <div
          id="vendorModal"
          className="modal fade"
          tabIndex="-1"
          role="dialog"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Add Vendor</h4>
                <button type="button" className="close" data-dismiss="modal">
                  <span>&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <form>
                  <div className="form-group">
                    <label>Vendor Name</label>
                    <input
                      type="text"
                      className="form-control"
                      onChange={this.props.onNameChange}
                    />
                  </div>
                  <div className="form-group">
                    <label>Account Number</label>
                    <input
                      type="text"
                      className="form-control"
                      onChange={this.props.onAccountChange}
                    />
                  </div>
                  <div className="form-group">
                    <label>Bank Details</label>
                    <input
                      type="text"
                      className="form-control"
                      onChange={this.props.onBankChange}
                    />
                  </div>
                  <div className="form-group">
                    <label>Address</label>
                    <textarea
                      className="form-control"
                      onChange={this.props.onAddressChange}
                    />
                  </div>
                  <div className="form-group">
                    <label>Phone Number</label>
                    <input
                      type="text"
                      className="form-control"
                      onChange={this.props.onPhoneChange}
                    />
                  </div>
                  <div className="form-group">
                    <label>GST</label>
                    <input
                      type="text"
                      className="form-control"
                      onChange={this.props.onGSTChange}
                    />
                  </div>
                  <div className="form-group">
                    <label>Item Of Supply</label>
                    <input
                      type="text"
                      className="form-control"
                      onChange={this.props.onItemofsupplyChange}
                    />
                  </div>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    onClick={this.props.addVendor}
                    data-dismiss="modal"
                  >
                    Add
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>


        {/* Edit Vendor Modal */}
        <div
          id="vendorEditModal"
          className="modal fade"
          tabIndex="-1"
          role="dialog"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Edit Vendor</h4>
                <button type="button" className="close" data-dismiss="modal">
                  <span>&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <form>
                  <div className="form-group">
                    <label>Vendor Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={this.state.vendor_name}
                      onChange={(e) => this.setState({ vendor_name: e.target.value })}
                    />
                  </div>
                  <div className="form-group">
                    <label>Account Number</label>
                    <input
                      type="text"
                      className="form-control"
                      value={this.state.acct_number}
                      onChange={(e) => this.setState({ acct_number: e.target.value })}
                    />
                  </div>
                  <div className="form-group">
                    <label>Bank Details</label>
                    <input
                      type="text"
                      className="form-control"
                      value={this.state.bank_details}
                      onChange={(e) => this.setState({ bank_details: e.target.value })}
                    />
                  </div>
                  <div className="form-group">
                    <label>Address</label>
                    <textarea
                      className="form-control"
                      value={this.state.address}
                      onChange={(e) => this.setState({ address: e.target.value })}
                    />
                  </div>
                  <div className="form-group">
                    <label>Phone Number</label>
                    <input
                      type="text"
                      className="form-control"
                      value={this.state.phone_number}
                      onChange={(e) => this.setState({ phone_number: e.target.value })}
                    />
                  </div>
                  <div className="form-group">
                    <label>GST</label>
                    <input
                      type="text"
                      className="form-control"
                      value={this.state.gst}
                      onChange={(e) => this.setState({ gst: e.target.value })}
                    />
                  </div>
                  <div className="form-group">
                    <label>Item Of Supply</label>
                    <input
                      type="text"
                      className="form-control"
                      value={this.state.item_of_supply}
                      onChange={(e) => this.setState({ item_of_supply: e.target.value })}
                    />
                  </div>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    onClick={(e) => {
                      e.preventDefault();
                      this.props.updateVendor(this.state);
                    }}
                    data-dismiss="modal"
                  >
                    UPDATE
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>

        {/* Vendors Table */}
        <div className="card">
          <div className="card-header d-flex justify-content-between">
            <h3 className="h4">Vendors</h3>
            <button
              className="btn btn-primary"
              data-toggle="modal"
              data-target="#vendorModal"
            >
              Add Vendor
            </button>
          </div>
          <div className="card-body">
            <div className="table-responsive">
              <table className="table text-center">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Vendor Name</th>
                    <th>Account Number</th>
                    <th>Bank Details</th>
                    <th>Address</th>
                    <th>Phone</th>
                    <th>GST</th>
                    <th>ItemOfSupply</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {this.props.vendors && this.props.vendors.length > 0 ? (
                    this.props.vendors.map((vendor, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{vendor.vendor_name}</td>
                        <td>{vendor.acct_number}</td>
                        <td>{vendor.bank_details}</td>
                        <td>{vendor.address}</td>
                        <td>{vendor.phone_number}</td>
                        <td>{vendor.gst}</td>
                        <td>{vendor.item_of_supply}</td>
                        <td>
                          <i
                            className="fa fa-edit mr-2"
                            data-toggle="modal"
                            data-target="#vendorEditModal"
                            onClick={() => this.updateVendorState(vendor)}
                          ></i>
                          <i
                            className="fa fa-trash"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              console.log("FULL VENDOR OBJECT:", vendor);

                              if (
                                window.confirm(
                                  "Are you sure you want to permanently remove " +
                                  vendor.vendor_name +
                                  " from Vendors"
                                )
                              ) {
                                console.log("VENDOR ID:", vendor.id);
                                this.props.deleteVendor(vendor.id);
                              }
                            }}
                          />
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="8">No Vendors Found</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default VendorComponent;
